import {IAvailability, TimeSlot} from "../models";
import firebase from "firebase";
import Timestamp = firebase.firestore.Timestamp;
import { AvailabilitySlot } from "../features/availability/availability.types";

export const isTimeSlotSelected = (slot:TimeSlot | undefined | null, availability: IAvailability) => {
    return slot?.start === availability.timeStart.toMillis() && slot?.end === availability.timeEnd.toMillis();
}

export const getSlot = (time_slot:TimeSlot): TimeSlot|null => {
    if(!!time_slot){
        return {
            start:time_slot.start,
            end:time_slot.end,
            offset:time_slot.offset
        }
    }
    return null;
}

export const convertTimeSlotTimestamp = (availability: AvailabilitySlot): IAvailability => {
    return {
        deliveryPercentage: availability.deliveryPercentage,
        offset: availability.offset,
        remainingDeliverySlots: availability.remainingDeliverySlots,
        remainingTakeAwaySlots: availability.remainingTakeAwaySlots,
        takeAwayPercentage: availability.takeAwayPercentage,
        timeEnd: firebase.firestore.Timestamp.fromMillis(availability.timeEnd),
        timeStart: firebase.firestore.Timestamp.fromMillis(availability.timeStart),
    
    }
}